import i18nFactory from '@yandex-int/i18n';

import { GroupId } from '../../typings/groups';

import * as keyset from './ErrorHelpers.i18n';

const i18n = i18nFactory(keyset);

export interface ErrorOrWarning {
    code: string;
    params: object | null;
    path: string;
}

interface ErrorProneHandleResponse {
    validationResult: null | {
        errors: Array<ErrorOrWarning>;
        warnings: Array<ErrorOrWarning>;
    };
    updatedAdGroupItems?: null | Array<null | {
        adGroupId: string;
    }>;
}

export const extractValidationErrors = (
    apiHandleResponse: ErrorProneHandleResponse
): [boolean, ErrorOrWarning[]] => {
    if (!apiHandleResponse.validationResult) {
        return [false, []];
    }
    return [
        apiHandleResponse.validationResult.errors.length !== 0,
        apiHandleResponse.validationResult.errors
    ];
};

export const extractUpdatedGroupIds = (
    apiHandleResponse: ErrorProneHandleResponse
): Array<GroupId> => {
    if (!apiHandleResponse.updatedAdGroupItems) {
        return [];
    }
    return apiHandleResponse.updatedAdGroupItems.reduce((acc, item) => {
        if (!item) {
            return acc;
        }
        return [...acc, item.adGroupId];
    }, []);
};

export const getErrorTextFromCountErrors = (errorsCount: number): string => {
    if (errorsCount === 1) {
        return i18n('one-block-error');
    }

    return i18n('block-errors', {
        count: errorsCount
    });
};
